/* eslint-disable jsx-a11y/anchor-has-content */
import { Trans } from "react-i18next";

export default function TransLink({
  t,
  textStyle = "",
  linkStyle,
  components = {},
}) {
  const effectiveLinkStyle = linkStyle || textStyle;

  const predefined = {
    quote: <a href="/quote" className={effectiveLinkStyle} />,
    roadmap: <a href="/roadmap" className={effectiveLinkStyle} />,
    upworkProfile: (
      <a
        href="https://www.upwork.com/freelancers/~01c455ecf87be6b791"
        target="_blank"
        rel="noopener noreferrer"
        className={effectiveLinkStyle}
      />
    ),
    neuroLink: (
      <a
        href="https://neurosharp.com.uy"
        target="_blank"
        rel="noopener noreferrer"
        className={effectiveLinkStyle}
      />
    ),
    aboutMe: <a href="/about" className={effectiveLinkStyle} />,
    myPortfolio: <a href="/portfolio" className={effectiveLinkStyle} />,
    abbLink: (
      <a
        href="https://new.abb.com/south-america/sobre-nosotros/quienes-somos/oficinas-sudamerica/uruguay"
        target="_blank"
        rel="noopener noreferrer"
        className={effectiveLinkStyle}
      />
    ),
    admeLink: (
      <a
        href="https://adme.com.uy/"
        target="_blank"
        rel="noopener noreferrer"
        className={effectiveLinkStyle}
      />
    ),
    uteLink: (
      <a
        href="https://www.ute.com.uy/"
        target="_blank"
        rel="noopener noreferrer"
        className={effectiveLinkStyle}
      />
    ),
  };

  const styledPassed = Object.fromEntries(
    Object.entries(components).map(([key, node]) => [
      key,
      node.type === "a"
        ? {
            ...node,
            props: {
              ...node.props,
              className: `${
                node.props?.className || ""
              } ${effectiveLinkStyle}`.trim(),
            },
          }
        : node,
    ])
  );

  return (
    <span className={textStyle}>
      <Trans i18nKey={t} components={{ ...predefined, ...styledPassed }} />
    </span>
  );
}
